// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"fbf6bcfa","513":"b1801fac","703":"d27acf72","787":"36663a18"}[chunkId] + ".chunk.js";
};